/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Checkbox, FilledButton } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(true);

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <Checkbox
        isChecked={isChecked}
        isIndeterminate={isIndeterminate}
        onChange={(event) => {
          setIsChecked(event.target.checked);
          setIsIndeterminate(event.target.indeterminate);
        }}
        ariaLabel="Indeterminate checkbox"
      />
      <div style={{ marginTop: '25px', width: '100%' }}>
        <div>Checkbox checked state: {isChecked.toString()}</div>
        <div>Checkbox indeterminate state: {isIndeterminate.toString()}</div>
      </div>
      <div>
        <FilledButton onClick={() => setIsChecked((prev: boolean) => !prev)}>
          Toggle checked
        </FilledButton>
        <FilledButton
          onClick={() => setIsIndeterminate((prev: boolean) => !prev)}
          style={{ marginLeft: '10px' }}
        >
          Toggle indeterminate
        </FilledButton>
      </div>
    </div>
  );
};

export default Component;
